export default __webpack_public_path__ + "static/media/pl.f9526606.png";